import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_processing_queue_RowClass } from '../../../dbschema';

export class DgMktCampaignProcessingQueueContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_processing_queue: bl_dgmkt_campaign_processing_queue_RowClass =
    new bl_dgmkt_campaign_processing_queue_RowClass();
}
